/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { slideInDown } from 'react-animations';
import glamorous from 'glamorous';
import { css } from 'glamor';
import { padding } from 'polished';
import maxedSidesSelector from 'app/selectors/maxedSidesSelector';
import lineUpSelector from 'app/selectors/lineUpSelector';
import t from 'app/utils/translate';

type Props = {
  lineUp: Array<Object>,
  maxValue: number,
  requiredSelections: number,
  sides: Array<string>,
};

const slideAnimation = css.keyframes(slideInDown);

const Info = glamorous.div(({ theme }) => ({
  animationDuration: '0.5s',
  animationName: slideAnimation,
  backgroundColor: theme.color.info,
  color: 'white',
  fontSize: '0.875rem',
  ...padding(5, 10),
  position: 'relative',
  textTransform: 'uppercase',
  zIndex: -1,
}));

function MaxedSidesInfo({
  lineUp,
  maxValue,
  requiredSelections,
  sides,
}: Props) {
  if (maxValue === 0 || sides.length === 0 || lineUp.length === requiredSelections) {
    return null;
  }

  return (
    <Info>
      <span className="ion-ios-information" />
      {' '}
      {
        t('Maximum of *maximum* players reached for *list*')
          .replace('*maximum*', maxValue)
          .replace('*list*', sides.join(', '))
      }
    </Info>
  );
}

const connector = connect(state => ({
  lineUp: lineUpSelector(state),
  maxValue: state.challenge.playersPerSideCap,
  requiredSelections: state.challenge.playerQuota + state.challenge.teamQuota,
  sides: maxedSidesSelector(state),
}), null);

export default connector(MaxedSidesInfo);
